import React from "react";
import useRequest from "../../../../utils/useRequest";
import {
    getNetCourseList,
    getNoWeekTimeCourseList
} from "../../../../service/course";
import Style from "../../Score/index.module.scss";
import { Button, Tooltip } from "antd";
import { BiUndo } from "react-icons/bi";
import { useHistory } from "react-router-dom";

interface Iprops {
    courseNo: string;
    courseSeq: string;
}

const Index = ({ courseNo, courseSeq }: Iprops) => {
    const history = useHistory();

    const [courseList] = useRequest(() => getNoWeekTimeCourseList());
    const [data] = useRequest(() => getNetCourseList());
    const courseInfo = [...(data || []), ...(courseList || [])].filter(
        item => item.courseSeq === courseSeq && item.courseNo === courseNo
    )[0];

    return (
        <div>
            <div className={Style.head}>
                <div>
                    <Tooltip
                        title={courseInfo?.courseName}
                        placement="bottomLeft">
                        <span className={Style.courseTitle}>
                            {courseInfo?.courseName}
                        </span>
                    </Tooltip>
                    <Button
                        size="small"
                        className={Style.goBack}
                        onClick={() => history.goBack()}>
                        <BiUndo size={16} />
                        返回
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Index;
